import { render } from "./PageBuilder.vue?vue&type=template&id=393ce9f0&ts=true"
import script from "./PageBuilder.vue?vue&type=script&lang=ts"
export * from "./PageBuilder.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__